// TODO merge with the one in capabilityMap/types.ts
export enum CommonDropdownOptions {
  ALL = '@@all@@',
  NONE = '@@none@@',
  PARENT_AS_REFERENCE = '@@parentAsReference@@',
  ALL_EXCEPT_DESELECTED_BY_DEFAULT = '@@allExceptDeselectedByDefault@@',
  ALL_EXCEPT_PARENT_CHILD = '@@allExceptParentChild@@',
}
